// my-custom-logger.service.ts
import { Injectable } from '@angular/core';
// Здесь можно импортировать интерфейс, если он объявлен в библиотеке
export interface ICustomLogger {
  logDebug(message: string, ...args: any[]): void;
  logWarning(message: string, ...args: any[]): void;
  logError(message: string, ...args: any[]): void;
}

@Injectable({
  providedIn: 'root',
})
export class MyCustomLogger implements ICustomLogger {
  logDebug(message: any, ...args: any[]): void {
    console.debug(`[OIDC-DEBUG]: ${message}`, ...args);
  }

  logError(message: any, ...args: any[]): void {
    console.error(`[OIDC-ERROR]: ${message}`, ...args);
  }

  logWarning(message: any, ...args: any[]): void {
    console.warn(`[OIDC-WARN]: ${message}`, ...args);
  }
}
